import React, { useEffect, useState } from 'react'
import { useParams, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux'
import { 
  Alert, Button, Checkbox, IcoEye, IcoEyeBlocked, Input, Loading, MaskData, MaskTelefoneInt, 
  passwordHas, SelectDefault, validacaoForm, validarCampo, validarSenhaConfirmar, verificaValidacao 
} from '../../components'
import { cadastrarUsuario, setChangeCadastro, setDisabledItem, setError, setSenhaVisivel } from './redux/loginActions'
import './login.scss'
import { history, idiomaString, IF } from '../../helpers'
import imgFrame from '../../layout/img/login/bg-2-front.png'
import imgLogo from '../../layout/img/logo-yellow.png'
import { getIp, listarEstados, modalAlertaInfo } from '../../layout/redux/layoutActions'
import ModalAlerta from '../../layout/modalAlerta'
import PhoneInput from 'react-phone-number-input'
import 'react-phone-number-input/style.css'

export default () => {
  const dispatch = useDispatch()
  const location = useLocation();
  const { load, sistema, listas, logIn } = useSelector(state => state.layoutState)
  const { senhaVisivel, cadastro, erro, disabledItem } = useSelector(state => state.loginState)
  const nls = require(`./nls/${sistema.idioma}.json`)
  const nlsPopup = require(`../../layout/nlsPopup/${sistema.idioma}.json`)

  const [tab, setTab] = useState(1)
  
  const idiomaCustom = e => {
    e = e === 'en-US' ? 'en' : e
    return e.toLowerCase()
  }
  
  const listPaises = listas.paisesIdiomas[idiomaCustom(sistema.idioma)]
  const listSegmentos = listas.segmentosIdiomas[idiomaCustom(sistema.idioma)]
  
  const termos = `${process.env.REACT_APP_TERMOS_DE_USO}`;
  const politica = `${process.env.REACT_APP_POLITICA_DE_PRIVACIDADE}`;
  
  useEffect(() => {
    if (!logIn) { 
      dispatch([getIp()])
    }
  }, [])
  
  useEffect(() => {
    const query = new URLSearchParams(location.search);
    const searchTerm = query.get('email');
    if (searchTerm) {
      dispatch(setDisabledItem({ name: 'Email', value: true }))
      dispatch(setChangeCadastro({ name: 'Email', value: searchTerm }))
    }
  }, [history.location])
  
  useEffect(() => {
    if (sistema?.pais?.codigoPais && !cadastro?.Pais) { 
      handleChange({ name: 'Pais', value: sistema.pais, pattern: 'select' })
    }
  },[sistema])

  const formRequiredP1 = {
    Email: 'email',
    Senha: 'senha',
    SenhaConfirma: 'senha',
  }

  const formRequired = {
    Nome: '',
    Sobrenome: '',
    Email: 'email',
    Celular: '',
    Empresa: '',
    Pais: 'select',
    Segmento: 'select',
    Senha: 'senha',
    SenhaConfirma: 'senha',
  }
  

  
const handleChange = e => {
  dispatch(setChangeCadastro(e))
  const hasReq = Object.keys(formRequired).includes(e.name);

  if (hasReq) {
    const verify = validarCampo(e)
    let message = verify.message

    if (e.name === 'SenhaConfirma') {
      message = validarSenhaConfirmar({ value: e.value, senha: cadastro.Senha })
    }

    if (e.name === 'Senha') {
      // revalida SenhaConfirma se ela já tiver sido preenchida
      if (cadastro.SenhaConfirma) {
        const confirmMessage = validarSenhaConfirmar({ value: cadastro.SenhaConfirma, senha: e.value })
        dispatch(setError({
          ...erro,
          [verify.name]: message,
          'SenhaConfirma': confirmMessage
        }))
        return
      }
    }

    dispatch(setError({ ...erro, [verify.name]: message }))
  }

  if (e.name === 'pais') {
    // dispatch(listarEstados(e.value))
  }
  handleChangeBlur(e)
}


  //Problema: só tira mensagem de erro no campo confirmação de senha
  //quando ajusta no campo de confirmação de senha e não no campo senha
  const handleChangeOLD = e => {
    dispatch(setChangeCadastro(e))
    const hasReq = Object.keys(formRequired).includes(e.name);
  
    if (hasReq) {
      const verify = validarCampo(e)
      
      let message = verify.message
      
      if (e.name === 'SenhaConfirma') {
        message = validarSenhaConfirmar({ value: e.value, senha: cadastro.Senha })
      }
  
      dispatch(setError({ ...erro, [verify.name]: message }))
    }
  
    if (e.name === 'pais') {
      // dispatch(listarEstados(e.value))
    }
    handleChangeBlur(e)
  }
  






  const handleChangeBlur = e => {
    const valid = validacaoForm({ formValues: { ...cadastro, [e.name]: e.value }, formRequired })
    const verify = verificaValidacao(valid)
    const senhasIguais = cadastro.Senha === cadastro.SenhaConfirma
    const termosVal = e.name === 'termos' ? e.value : cadastro.termos
    let valor = true
    if (verify.value && senhasIguais && termosVal) {
      valor = false
    }
    dispatch(setDisabledItem({ name: 'cadastrar', value: valor }))
  }
  
  const handleSee = e => {
    dispatch(setSenhaVisivel(e))
  }
  
  const handleCriar = e => {
    const valid = validacaoForm({ formValues: e, formRequired })
    dispatch(setError(valid))
    const verify = verificaValidacao(valid)
    const termosVal = e.termos
    if (e.Senha !== e.SenhaConfirma) {
      dispatch(setError({ ...erro, 'senhaConfirma': 'different' }))      
    }
    if (verify.value && e.Senha === e.SenhaConfirma && termosVal) {
      dispatch(cadastrarUsuario({ ...e, IpCadastro: sistema.getip.ipaddress }, nls, nlsPopup))
    }
  }

  const nextPasso = (formValues, formRequired) => {
    const valid = validacaoForm({formValues, formRequired})
    dispatch(setError(valid))
    const verify = verificaValidacao(valid)
    if (formValues.Senha !== formValues.SenhaConfirma) {
      dispatch(setError({...erro, 'senhaConfirma': 'different'}))      
    }
    if (verify.value && formValues.Senha === formValues.SenhaConfirma) {
      setTab(2)
    }
  }

  return (
    <div className='box-login'>
      <Alert />
      <div className='box-login-container'>
        <div className='box-login-frame'>
          <img src={imgFrame} alt="Frame" />
        </div>
        <div className='box-login-form'>
          <div className='box-login-content'>
            <div className='box-login-logo'>
              <img src={imgLogo} alt="Logo" />
            </div>
            <div className='box-login-info'>
              <h2>{nls?.cadastrar.title}</h2>
            </div>
            <IF se={tab === 1}>
              <div className='colflex col1'>
                <Input
                  // label={nls?.formEmail}
                  name='Email'
                  action={(e) => handleChange(e)}
                  actionBlur={(e) => handleChangeBlur(e)}
                  value={cadastro.Email}
                  placeholder={nls?.formEmail}
                  required={{
                    erro,
                    message: nls.mensagem,
                    pattern: formRequired.Email
                  }}
                />
              </div>
              <div className='colflex col2'>
                <div> 
                  <Input
                    // label={nls?.formSenha}
                    name='Senha'
                    type={!senhaVisivel.Senha?'password':'text'}
                    action={(e) => handleChange(e)}
                    actionBlur={(e) => handleChangeBlur(e)}
                    value={cadastro.Senha}
                    placeholder={nls?.formSenha}
                    right={
                      <Button type='link' onClick={()=> handleSee({name: 'Senha', value: !senhaVisivel.Senha})}>
                        {!senhaVisivel.Senha ? <IcoEye />
                        : <IcoEyeBlocked />}
                      </Button>
                    }
                  />
                  {cadastro.Senha ? 
                    <div className='regras-senha' dangerouslySetInnerHTML={{__html: passwordHas(cadastro.Senha,nls)}}></div> 
                  :null}
                </div>
                <div>
                    <Input
                      // label={nls?.formSenhaConfirmar}
                      name='SenhaConfirma'
                      type={!senhaVisivel.SenhaConfirma?'password':'text'}
                      action={(e) => handleChange(e)}
                      actionBlur={(e) => handleChangeBlur(e)}
                      value={cadastro.SenhaConfirma}
                      placeholder={nls?.formSenhaConfirmar}
                      right={
                        <Button type='link' onClick={()=> handleSee({name: 'SenhaConfirma', value: !senhaVisivel.SenhaConfirma})}>
                          {!senhaVisivel.SenhaConfirma ? <IcoEye />
                          : <IcoEyeBlocked />}
                        </Button>
                      }
                      required={{
                        erro,
                        message: nls.mensagem,
                        pattern: formRequired.SenhaConfirma
                      }}
                    />
                </div>
              </div>
              <div className='box-login-action'>
                <div className='box-login-action-btns'>
                  <Button
                    color='primary'
                    variant='outlined'
                    onClick={()=> history.push('/login')}
                  >{nls?.btnCancelar}</Button>
                  <Button
                    color='primary'
                    onClick={()=> nextPasso(cadastro, formRequiredP1)}
                  >{nls?.btnProximo}</Button>
                </div>
              </div>
            </IF>


            <IF se={tab === 2}>
              <div className='colflex col2'>
                <Input
                  // label={nls?.formNome}
                  name='Nome'
                  action={(e) => handleChange(e)}
                  actionBlur={(e) => handleChangeBlur(e)}
                  value={cadastro.Nome}
                  placeholder={nls?.formNome}
                  required={{
                    erro,
                    message: nls.mensagem.obrigatorio,
                    pattern: formRequired.Nome
                  }}
                />
                <Input
                  // label={nls?.formSobrenome}
                  name='Sobrenome'
                  action={(e) => handleChange(e)}
                  actionBlur={(e) => handleChangeBlur(e)}
                  value={cadastro.Sobrenome}
                  placeholder={nls?.formSobrenome}
                  required={{
                    erro,
                    message: nls.mensagem.obrigatorio,
                    pattern: formRequired.Sobrenome
                  }}
                />
              </div>
              <div className='colflex col2'>
                {/* Campo Celular substituído por PhoneInput */}
                <div className="custom-phone-input">
                  <PhoneInput
                    name="Celular"
                    value={cadastro?.Celular}
                    country={cadastro?.Pais ? cadastro.Pais.codigoPais : undefined}
                    defaultCountry={cadastro?.Pais ? cadastro.Pais.codigoPais : undefined}
                    countrySelectProps={{ disabled: true }}
                    key={cadastro?.Pais ? cadastro.Pais.codigoPais : 'default'}
                    placeholder={nls.formCelular}
                    limitMaxLength
                    onChange={value => {
                      dispatch(setChangeCadastro({ name: 'Celular', value }))
                      handleChangeBlur({ name: 'Celular', value })
                    }}
                    onBlur={() => handleChangeBlur({ name: 'Celular', value: cadastro.Celular })}
                  />
                </div>
                <Input
                  name='Empresa'
                  // label={nls?.formEmpresa}
                  value={cadastro?.Empresa}
                  placeholder={nls?.formEmpresa}
                  action={(e) => handleChange(e)}
                  actionBlur={(e) => handleChangeBlur(e)}
                  maxLength='20'
                  required={{
                    erro,
                    message: nls.mensagem.obrigatorio,
                    pattern: formRequired.Empresa
                  }}
                />
              </div>
              <hr />
              <div className='colflex col2'>
                <SelectDefault
                  name='Pais'
                  // label={nls?.formPais}
                  options={listPaises}
                  selected={cadastro?.Pais?cadastro?.Pais:''}
                  action={(e) => handleChange(e)}
                  actionBlur={(e) => handleChangeBlur(e)}
                  textCustom={nls.selectPais}
                  optionLabel='nomePais'
                  optionValue='idPais'
                  required={{
                    erro,
                    message: nls.mensagem.obrigatorio,
                    pattern: formRequired.Pais
                  }}
                />
                <SelectDefault
                  name='Segmento'
                  // label={nls?.formSegmento}
                  options={listSegmentos}
                  selected={cadastro?.Segmento?cadastro?.Segmento:''}
                  action={(e) => handleChange(e)}
                  actionBlur={(e) => handleChangeBlur(e)}
                  textCustom={nls.selectSegmento}
                  optionLabel='nome'
                  optionValue='id'
                  required={{
                    erro,
                    message: nls.mensagem.obrigatorio,
                    pattern: formRequired.Segmento
                  }}
                />
              </div>
              <hr />
              <div className=''>
                <Checkbox
                  name='termos'
                  checked={cadastro.termos}
                  action={e=> {
                    handleChange(e)
                    handleChangeBlur(e)
                  }}
                  text={
                    <span
                      dangerouslySetInnerHTML={{
                        __html: nls?.cadastrar.termos
                          .replace('${linkTermosDeUso}', termos)
                          .replace('${linkPoliticaDePrivacidade}', politica),
                      }}
                    />
                  }
                />
              </div>
              <div className=''>
                <Checkbox
                  name='novidades'
                  checked={cadastro.novidades}
                  action={e=> {
                    handleChange(e)
                  }}
                  text={nls?.cadastrar.novidades}
                />
              </div>
              <div className=''>
                <p>{nls?.cadastrar.novidadesInfo}</p>
              </div>
              <div className='box-login-action'>
                <div className='box-login-action-btns'>
                  <Button
                    color='primary'
                    variant='outlined'
                    onClick={()=> setTab(1)}
                  >{nls?.btnAnterior}</Button>
                  <Button
                    color='primary'
                    onClick={()=> handleCriar(cadastro)}
                    disabled={disabledItem.cadastrar}
                  >{nls?.btnCriarConta}</Button>
                </div>
              </div>
            </IF>
            
          </div>
        </div>
      </div>
      {load ? <Loading title={nls.mensagem.carregando} /> : null}
      <ModalAlerta />
    </div>
  )
}
